const state = {
    popupLoader: true,
    popupLoaderError: false
}

const mutations = {
    UPDATE_LOADER_STATE(state, payload) {
        state.popupLoader = payload
    },

    UPDATE_LOADER_STATE_SET_ERROR(state, payload) {
        state.popupLoaderError = payload
    }
}

const getters = {
    popupLoader: state => state.popupLoader,
    popupLoaderError: state => state.popupLoaderError
}

export default {
    state,
    mutations,
    getters
}
